import MobileDesktopRender from './MobileDesktopRender';
import MediaQueryWatch from './MediaQueryWatch';

export default MobileDesktopRender;

export { MediaQueryWatch };
